import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Partner } from '../interfaces/partner';

@Component({
  selector: 'app-partner-card',
  templateUrl: './partner-card.component.html',
  styleUrl: './partner-card.component.css'
})
export class PartnerCardComponent {
  @Input() partner!: Partner;
  @Output() cardClicked: EventEmitter<String> = new EventEmitter();
  
  onCardClick() {
    this.cardClicked.emit(this.partner.urlOrg);
  }
}
